import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { environment } from "src/environments/environment";
import { map, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SipService {
    constructor(
        private api: ApiService
    ) {}

    getSipSubscriptions(entityId: number, currency: string) {
        const url = environment.APP.API_URLS.GET_SIP_SUBSCRIPTIONS(entityId);
        return this.api.get(url + `?currency=${currency}`).pipe(
            map((resData: any) => resData.data.filter(item => {
                item.cause_saves = '14k+' + this.getSipSavesText(item);
                return item;
            }))
        );
    }

    sipParamUrl = (multiCauses, firstAmount) => (multiCauses.length > 1 ? JSON.stringify(multiCauses.map((value) => ({ sip_cause: value, amount: firstAmount }))) : multiCauses[0]);

    postNewSipSubscribeOnDemand(entityId: number, data: any) {
        const url = environment.APP.API_URLS.POST_SUBSCRIPTION_PAYMENTS(entityId);
        return this.api.post(url, data); 
    }

    fetchSubscriptionCurrency = (latestOrder, userData) => (latestOrder?.ondemandSubscription ? latestOrder?.ondemandSubscription?.currency.toUpperCase() : userData?.latest_subscription?.currency.toUpperCase());

    fetchSubscriptionAmount = (firstSub, currency) => {
        const currSymbol = firstSub ? firstSub?.currency?.toUpperCase() : currency?.toUpperCase();
        switch (currSymbol) {
          case 'INR':
            return this.firstAmountLogic(firstSub?.amount, 100, !firstSub, firstSub?.currency == 'inr');
          case 'USD':
          case 'GBP':
          case 'EUR':
          case 'CAD':
          case 'HKD':
          case 'QAR':
          case 'AUD':
          case 'MYR':
            return this.firstAmountLogic(firstSub?.amount, 10, !firstSub);
          case 'AED':
            return this.firstAmountLogic(firstSub?.amount, 20, !firstSub);
          case 'SGD':
            return this.firstAmountLogic(firstSub?.amount, 30, !firstSub);
          case 'SAR':
            return this.firstAmountLogic(firstSub?.amount, 50, !firstSub);
          default:
            return this.firstAmountLogic(firstSub?.amount, 100, !firstSub);
        }
    };

    getCauseAmount = () => {
        if (window['causeAmount'] !== undefined) {
            return window['causeAmount'];
        }
    };
    
    firstAmountLogic = (newAmount, defaultAmount, checkNull, checkInr = false) => {
        if (checkNull) {
            return defaultAmount;
        }
        if (checkInr && !this.getCauseAmount()) {
            return newAmount < defaultAmount ? newAmount : defaultAmount;
        }
        if (this.getCauseAmount()) {
            return newAmount || defaultAmount;
        }
        return defaultAmount;
    };

    getSipSavesText(sipObject: any) {
        const textObject = {
            'education': ' kids educated',
            'food_hunger': ' people fed',
            'animals': ' animals saved',
            'elderly': ' elderly supported',
            'acid_victims': ' people supported',
            'women_girls': ' girls empowered',
            'widow': ' widow supported',
            'medical': ' lives saved'
        }

        return textObject[sipObject.campaign_cause];
    }

    getPledgeAmt(currency, amt) {
        const newAmt = parseInt(amt) + (parseInt(amt) * 0.33);  
        if (currency == 'INR') {
          return newAmt + (100 - (newAmt % 100 ? newAmt % 100 : 100));
        }
        // USD, EUR, GBP, AED, SAR, SGD
        return newAmt + (10 - (newAmt % 10 ? newAmt % 10 : 10));
    };


    resumePausedSip(entityId, subsId, payload) {
        const url = environment.APP.API_URLS.PUT_ACTIVATE_SUBSCRIPTION(entityId, subsId);
        return  this.api.put(url, payload);
    }
}